<template>
  <div>
    <!-- 订单修改 -->
    <el-dialog :close-on-click-modal="false"
      :title="titleType"
      :visible.sync="editDialogVisible"
      :before-close="editHandleClose"
      width="60%"
      center
      top="15vh"
    >
      <el-divider></el-divider>
      <div class="infoForm">
        <el-form ref="form" :model="form" label-width="140px">
          <div class="itemOne">
            <el-form-item label="单号:">
              <span class="xingA">*</span>
              <el-input v-model="oddnumbers" placeholder="请输入单号"></el-input>
            </el-form-item>
            <el-form-item label="团队名称:">
              <span class="xingB">*</span>
              <el-input v-model="form.itemName" placeholder="请输入团队名称"></el-input>
            </el-form-item>
          </div>
          <div class="itemTwo">
            <div>
              <el-form-item label="联系人姓名:">
                <span class="xingC">*</span>
                <el-input v-model="form.name" placeholder></el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="联系人号码:">
                <span class="xingC">*</span>
                <el-input v-model="form.mobile" placeholder></el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="身份证号码:">
                <el-input v-model="form.code" placeholder></el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="人数:">
                <span class="xingA">*</span>
                <el-input v-model="form.num" placeholder></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="itemThree">
            <div>
              <el-form-item label="选择景区:">
                <span class="xingD">*</span>
                <el-select v-model="form.ScenicID" placeholder="请选择景区" @change="scenChange">
                  <el-option
                    v-for="item in scenic"
                    :key="item.ScenicID"
                    :label="item.Name"
                    :value="item.ScenicID"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="项目名称:">
                <span class="xingD">*</span>
                <!-- <el-select v-model="form.ItemID" placeholder="项目名称">
                  <el-option
                    v-for="item in Auth"
                    :key="item.ItemID"
                    :label="item.goods_name"
                    :value="item.ItemID"
                  ></el-option>
                </el-select> -->
                <div @click="openXm">点击进行选择项目</div>
              </el-form-item>
            </div>
          </div>
          <div class="itemFour">
            <div>
              <el-form-item label="执行时间:">
                <el-date-picker v-model="form.useTime" type="datetime" placeholder="选择日期时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                clearable
                ></el-date-picker>
                <div>
                  <span>注:</span>
                  <span>请提前一天预定</span>
                </div>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="计价总金额:">
                <span class="xingE">*</span>
                <el-input v-model="form.totalPrice" placeholder disabled></el-input>
                <span>元</span>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="审核结果通知号码:">
                <span class="xingF">*</span>
                <el-input v-model="form.informMobile" placeholder></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="itemFive">
            <el-form-item label="游客信息:" class="flexs">
              <el-input v-model="form.excel" placeholder="请输入游客信息"></el-input>
              <el-upload class="avatar-uploader" action="http://xwt.softykt.net/api/res/addResFile" :show-file-list="false"
                  :on-success="handleAvatarSuccess">
                   <el-button type="primary">上传 <i class="el-icon-upload2"></i></el-button>
                </el-upload>
            </el-form-item>
            <div class="txt_mbo">*可根据景区需求上传游客信息文件,样式模板可点击下载</div>
          </div>
          <div class="itemSex">
            <el-form-item label="订单备注:">
              <el-input
                type="textarea"
                :autosize="{minRows:3,maxRows:5}"
                v-model="form.des"
                placeholder="--"
              ></el-input>
            </el-form-item>
          </div>
          <div class="itemBtn">
            <el-form-item>
              <el-button>复位</el-button>
              <el-button class="btnL" @click="btns">确认修改</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <div class="mask" v-if="flow">
        <div class="box">
            <div class="title">
               <span>详情</span>
               <img src="@/images/distributor/Grou.png" alt="" @click="CloseXm">
            </div>
            <div class="Names">
              <div>
                <span>景区名称</span>
                <span v-for="item in scenic" :key="item.ScenicID" v-if="item.ScenicID==form.ScenicID">{{ item.Name }}</span>
              </div>
               <div>
                注：价格仅支持整数，出现小数将把小数抹为0
               </div>
            </div>
            <el-table
            ref="multipleTable"
            :data="Auth"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
            >
            <el-table-column
              type="selection"
              reserve-selection="true"
              >
            </el-table-column>
            <!-- <el-table-column>
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.checks">备选项</el-checkbox>
              </template>
            </el-table-column> -->
            <el-table-column
              label="产品名称"
              >
              <template slot-scope="scope">{{ scope.row.goods_name }}</template>
            </el-table-column>
            <el-table-column
              label="建议价格"
              >
               <template slot-scope="scope">
                  <el-input v-model="scope.row.SellPrice"></el-input>
               </template>
            </el-table-column>
            <el-table-column
              prop="Price"
              label="最低售卖价"
              show-overflow-tooltip>
            </el-table-column>
            <el-table-column
              label="有效期">
            <template slot-scope="scope">
              {{ scope.row.ValidBeginDate }} - {{ scope.row.ValidEndDate }}
            </template>
          
            </el-table-column>
            <el-table-column label="支持退货">
              <template slot-scope="scope">
                {{ scope.row.ValidBeginDate=='0'?'允许退货':'不予退货' }} 
            </template>
            </el-table-column>
            <el-table-column
              label="预定数量">
              <template>
                  {{ form.num }}
              </template>
            </el-table-column>
          </el-table>
        </div>
    </div>
  </div>
</template>

<script>
import { addResOrder, getResDisItemAuthList,getResOrderInfo,updateResOrder} from '@/request/distributor.js'
import {Message} from 'element-ui'
export default {
  props:['scenic','orderId'],
  data() {
    return {
      editDialogVisible:false,
      oddnumbers:"R_2023032955529953",// 订单修改
      titleType: "",
      form: {
        token:window.sessionStorage.getItem('Token'),
        itemName:"",//团队名称
        name: "",//联系人
        excel:"", //游客信息 excel文件
        mobile:'',//手机号
        num:'',//人数
        ScenicID:'',
        useTime:'',//使用日期
        informMobile:'', //通知手机号
        ItemID:"", //商品id
        singlePrice:"", // 价格
        code:"",//身份证号
        des:"",//备注
        totalPrice:0 //总价
      },
      Auth:[],
      value: "",
      value1:'',
      value2:'',
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            }
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          }
        ]
      },
      excel:"",
      flow: false,
      priList:[],
      scenid:''
    };
  },
  created(){
    if(this.orderId){
      this.getList()
    }
  },
  methods: {
    getList(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        resorderid:this.orderId
      }
      getResOrderInfo(data).then(res=>{
        console.log(res)
        if(res.data.status=='ok'){
          this.form = res.data.result
          this.form.token = window.sessionStorage.getItem('Token')
          this.form.excel = res.data.result.file_rootpath
          this.priList = res.data.result.res_goods
          this.scenid = res.data.result.ScenicID
          this.AuthList()
        }
      })
    },
    //商品
    AuthList(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        ScenicID:this.scenid
      }
      getResDisItemAuthList(data).then(res=>{
        if(res.data.status=='ok'){
          this.Auth = res.data.result
          
        }
      })
    },
    // 订单修改
    editOrder(row) {
      if (row) {
        this.titleType = "订单修改";
      } else {
        this.titleType = "添加预订单";
      }
      this.editDialogVisible = true;
    },
    // 订单修改X
    editHandleClose() {
      this.editDialogVisible = false;
      this.$emit('Close')
      this.form = {}
    },
    // 上传
    handleAvatarSuccess(res) {
      console.log(res)
      this.form.excel = res.result
    },
    // 提交
    btns(){
      if(this.orderId){
        this.form.singlePrice  = ''
        this.form.ItemID  = ''
        this.priList.map(item=>{
          this.Auth.map(itm=>{
            if(item.ItemID==itm.ItemID){
              this.form.ItemID += itm.ItemID + ',' 
              this.form.singlePrice += itm.SellPrice + ','  
            }
          })
        })
        let form = {
            token:window.sessionStorage.getItem('Token'),
            ResOrderID:this.orderId,
            itemName:this.form.itemName,
            name : this.form.name,
            excel:this.form.excel,
            mobile:this.form.mobile,
            num:this.form.num,
            ScenicID:this.scenid,
            useTime:this.form.useTime,
            informMobile:this.form.informMobile,
            code:this.form.code,
            des:this.form.des,
            ItemID:this.form.ItemID,
            singlePrice:this.form.singlePrice
        }
        form.ItemID = form.ItemID.substr(0,form.ItemID.length-1)
        form.singlePrice = form.singlePrice.substr(0,form.singlePrice.length-1)
        updateResOrder(form).then(res=>{
          if(res.data.status=='ok'){
            this.editDialogVisible = false;
            this.$emit('again')
            Message.success(res.data.msg);
          }else{
            Message.error(res.data.msg);
          }
        })
      }else{
        this.priList.map(item=>{
        if(this.form.ItemID!=''){
          this.form.ItemID = this.form.ItemID + ',' +  item.ItemID
        }else{
          this.form.ItemID = item.ItemID 
        }
        if(this.form.singlePrice!= ''){
          console.log(this.form.singlePrice )
          this.form.singlePrice = this.form.singlePrice + ',' +  item.SellPrice
        }else{
          console.log(item)
          this.form.singlePrice = item.SellPrice 
        }
      })
        let form = {
        token:window.sessionStorage.getItem('Token'),
        itemName:this.form.itemName,
        name : this.form.name,
        excel:this.form.excel,
        mobile:this.form.mobile,
        num:this.form.num,
        ScenicID:this.scenid,
        useTime:this.form.useTime,
        informMobile:this.form.informMobile,
        code:this.form.code,
        des:this.form.des,
        ItemID:this.form.ItemID,
        singlePrice:this.form.singlePrice
      }
        addResOrder(form).then(res=>{
        if(res.data.status=='ok'){
          this.editDialogVisible = false;
          this.$emit('again')
          Message.success(res.data.msg);
        }else{
          Message.error(res.data.msg);
        }
      })
      }
     
      
    },
    uploadImg(param){
      this.form.excel = param
      this.excel = param.name
    },
    openXm(){
      this.Auth.map(item=>{
        this.priList.map(itm=>{
          if(item.ItemID==itm.ItemID){
            setTimeout(() => {
              this.$refs.multipleTable.toggleRowSelection(item, true);
            }, 200);
          }
        })
      })
      this.flow = true
    },
    CloseXm(){
      console.log(1)
      this.flow = false
      this.priList.map(item=>{
        this.form.totalPrice = Number(this.form.totalPrice) + (item.SellPrice * this.form.num) 
      })
    },
    handleSelectionChange(val){
      this.priList = val
    },
    scenChange(e){
      this.scenid = e
      this.AuthList()
    },
     // 表格全选
     toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
  }
};
</script>

<style lang='less' scoped>
.mask{
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  z-index: 9999;
  .box{
    width: 114rem;
    max-height: 61rem;
    background: #ffffff;
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    .title{
      padding: 1.8rem 0;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-content: center;
      position: relative;
      border-bottom: 1px solid #E5E5EA;
      span{
        color: #000000;
        font-size: 2rem;
        font-weight: 600;
      }
      img{
        width: 1.8rem;
        height: 1.8rem;
        position: absolute;
        right: 2rem;
        top: 50%;
        transform: translate(0,-50%);
        cursor: pointer;
      }
    }
    .Names{
      padding: 0 2rem;
      display: flex;
      justify-content: space-between;
      margin-top: 1.8rem;
      span{
        font-size: 1.4rem;
        &:nth-child(1){
          color: #000000;
        }
        &:nth-child(2){
          color: #666666;
          margin-left: 1rem;
        }
      }
      >div{
        &:nth-child(2){
          color: #E74C3C;
          font-size: 1.4rem;
        }
      }
    }
  }
}
.infoForm {
  .el-form-item {
    position: relative;
  }
  .xingA {
    position: absolute;
    top: 0px;
    left: -50px;
    color: #e74c3c;
  }
  .xingB {
    position: absolute;
    top: 0px;
    left: -78px;
    color: #e74c3c;
  }
  .xingC {
    position: absolute;
    top: 0px;
    left: -92px;
    color: #e74c3c;
  }
  .xingD {
    position: absolute;
    top: 0px;
    left: -78px;
    color: #e74c3c;
  }
  .xingE {
    position: absolute;
    top: 0px;
    left: -102px;
    color: #e74c3c;
  }
  .xingF {
    position: absolute;
    top: 0px;
    left: -134px;
    color: #e74c3c;
  }
  .itemOne {
    display: flex;
    flex-wrap: wrap;
    .el-input {
      width: 370px;
    }
  }
  .itemTwo {
    display: flex;
    flex-wrap: wrap;
    > div:nth-child(1) {
      .el-input {
        width: 110px;
      }
    }
    > div:nth-child(2) {
      /deep/.el-form-item {
        margin-left: -40px;
      }
      .el-input {
        width: 160px;
      }
    }
    > div:nth-child(3) {
      /deep/.el-form-item {
        margin-left: -40px;
      }
      .el-input {
        width: 240px;
      }
    }
    > div:nth-child(4) {
      /deep/.el-form-item {
        margin-left: -80px;
      }
      .el-input {
        width: 110px;
      }
    }
  }
  .itemThree {
    display: flex;
    > div:nth-child(1) {
      .el-select {
        width: 230px;
      }
    }
    > div:nth-child(2) {
      .el-select {
        width: 510px;
      }
    }
  }
  .itemFour {
    display: flex;
    flex-wrap: wrap;
    > div:nth-child(1) {
      .el-date-picker {
        width: 200px;
      }
      > div:nth-child(1) {
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #e74c3c;
        span {
          margin-right: 10px;
        }
      }
    }
    > div:nth-child(2) {
      /deep/.el-form-item {
        margin-left: -40px;
      }
      .el-input {
        width: 187px;
      }
      span {
        margin: 0 10px;
      }
    }
    > div:nth-child(3) {
      .el-input {
        width: 200px;
      }
    }
  }
  .itemFive {
    .el-button {
      width: 110px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #246deb;
      background: #ffffff;
      border: 1px solid #246deb;
      border-radius: 4px;
    }
    > div {
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #e74c3c;
    }
    .el-input {
      width: 300px;
      margin-right: 20px;
    }
  }
  .itemBtn {
    display: flex;
    justify-content: center;
    margin-left: -130px;
    .el-button {
      width: 100px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      border: none;
      margin-right: 10px;
      margin-top: 20px;
    }
    .btnL {
      width: 100px;
      background: #246deb;
      border-radius: 4px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      border: none;
    }
  }
}
::v-deep .el-upload-dragger{
  border: none;
  width: 110px;
  height: 40px;
}
.mask ::v-deep .el-table{
    height: 500px;
    overflow: auto;
}
.flexs ::v-deep .el-form-item__content{
  display: flex;

}
.txt_mbo{
  margin-bottom: 1rem;
  margin-left: 14rem;
}
</style>